import { useRouter } from 'next/router';
import { useMemo } from 'react';

import NavbarJobPage from "components/NavbarJobPage";
import FooterJob from "../FooterJob";
import MainHead from "../main/MainHead";
import { appHostProd } from 'utils/constants';
import config from 'utils/config';
import FooterCtaMobileApp from 'components/landing/FooterCtaMobileApp';

const JobPageLayout: React.FC<{
  children: React.ReactNode;
  hasLoginToken?: boolean;
  title?: string;
  keywords?: string;
  description?: string;
  titleOg?: string;
  descriptionOg?: string;
  imageUrl?: string;
  hostUrl?: string;
  author?: string;
  type?: string;
}> = ({
  title,
  keywords,
  description,
  children,
  hasLoginToken,
  type,
}) => {
    const isMainDomain = config.cookiesConfig.domain === appHostProd;
    const router = useRouter();
    const isNotWhitelistedCompany = useMemo(() => {
      return router.query?.notCompany === 'true';
    }, [router.query?.notCompany]);

    return (
      <>
        <MainHead
          title={title}
          description={description}
          keywords={keywords}
          robots={isMainDomain ? 'index,follow' : 'noindex,nofollow,noarchive'}
          googleBot={isMainDomain ? 'index,follow' : 'noindex,nofollow,noarchive'}
        />

        <div className="w-full min-h-screen landing">
          {isNotWhitelistedCompany && (
            <NavbarJobPage
              hasLoginToken={hasLoginToken}
              type={type}
            />
          )}
          {children}

          {isNotWhitelistedCompany && (
            <div className='-mb-100'>
              <FooterCtaMobileApp />
            </div>
          )}
          
          <FooterJob
            isNotWhitelistedCompany={isNotWhitelistedCompany}
            type={type}
          />
        </div>
      </>
    );
  };

export default JobPageLayout;
